import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { FileInput, SelectInput, TextInput, PhoneInput } from "../../components/inputs";
import countries from '../../utils/data/countries.json'
import timezones from '../../utils/data/timezones.json'
import { getImage, isValidEmail, successToast } from "../../utils";
import { createAdministrator } from "../../store/user/userActions";
import { useNavigate } from "react-router";

const CreateAdmin = () => {

    const { user } = useSelector((state) => state.auth);
    const dispatch = useDispatch()
    const {
        register,
        handleSubmit,
        watch,
        setError,
        control,
        formState: { errors },
    } = useForm();
    
    const navigate = useNavigate()
    const onSubmit = async (data) => {
        console.log("data ", data);
        dispatch(createAdministrator(data))
        .then(() => navigate("/users/list"))
    };


    const options = countries.map((country) => { return { value: country.iso, label: country.name } })
    const timezoneOptions = timezones.map((timezone) => { return { value: timezone, label: timezone } })

    return (
        <>
            <form noValidate id="admin-form" className={"bg-white rounded-2xl p-5 w-2/4 mx-auto flex flex-col"} onSubmit={handleSubmit(onSubmit)}>
                <FileInput
                    name="avatar"
                    label="Avatar"
                    errors={errors}
                    register={register}
                    setError={setError}
                    control={control}
                    defaultValue={watch("avatar")}
                    style="avatar"
                    required
                />

                <div className="flex gap-10 mt-5">
                    <TextInput
                        name="firstName"
                        label="First Name"
                        errors={errors}
                        register={register}
                        control={control}
                        validationSchema={{
                            required: "This field is required"
                        }}
                    />
                    <TextInput
                        name="lastName"
                        label="Last Name"
                        errors={errors}
                        register={register}
                        control={control}
                        validationSchema={{
                            required: "This field is required"
                        }}
                    />
                </div>

                <TextInput
                        name="email"
                        label="Email"
                        type="email"
                        errors={errors}
                        register={register}
                        control={control}
                        validationSchema={{
                            required: "This field is required",
                            validate: (value) =>
                                isValidEmail(value) || "Please enter a valid email address",
                        }}
                    />

                <TextInput
                    name="password"
                    label="New Password"
                    className=""
                    type={"password"}
                    validationSchema={{
                        validate: (v) => v.length < 8 ? "The password must be at least 8 characters long": true
                    }}
                    errors={errors}
                    register={register}
                    control={control}
                />

                <button className="bg-nt-blue text-white p-2 px-4 rounded self-center">
                    Save
                </button>

            </form>

        </>
    )
}
export { CreateAdmin }